import { AfterViewInit, OnDestroy, Component, ChangeDetectorRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { FormGroup } from '@angular/forms';

type FormErrorService = {
    error$?: Observable<Record<string, { message?: string }> | any>;
};

@Component({
    selector: 'ashcorp-form',
    templateUrl: './form.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AshcorpFormComponent implements AfterViewInit, OnDestroy {
    private _unsubscribeAll: Subject<void> = new Subject<void>();

    @Input() formGroup!: FormGroup;
    @Input() service: FormErrorService | null = null;
    @Input() formClass = 'mt-5';
    @Output() ngSubmit: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private _cdr: ChangeDetectorRef
    ) {
    }

    onSubmit(): void {
        // this.ngSubmit.emit(); ignore as it will submit the form twice
    }

    ngAfterViewInit() {
        if (!this.formGroup) {
            return;
        }

        const errorStream = this.service?.error$;
        if (!errorStream || typeof errorStream.pipe !== 'function') {
            return;
        }

        errorStream
            .pipe(
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(
                {
                    next: (error: any) => {
                        Object.entries(error).forEach(([key, value]: [string, any]) => {
                            if (key === 'error_id') return;
                            this.formGroup.get(key)?.setErrors({ server: value.message });
                        });
                        this._cdr.detectChanges();
                    }
                }
            );
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
